import Navbar from '../components/Console/Navbar'
import Sidebar from '../components/Console/Sidebar'

import React, {useState} from 'react'
import HeroSection from '../components/Console/HeroSection'
import InfoSection from '../components/Console/InfoSection'
import ProblemSection from '../components/Console/ProblemSection'

import {HowtoSectionData, InfoSectionData } from '../components/Console/InfoSection/Data'
import { ProblemSectionData, ContentSectionData, PreFooterData } from '../components/Console/ProblemSection/Data'
import HowtoSection from '../components/Console/HowtoSection'
import ContentSection from '../components/Console/ContentSection'
import PreFooter from '../components/Console/PreFooter'
import ConsoleFooter from '../components/Console/Footer'
import ConsultForm from '../components/Console/ConsultForm'


const Console = () => {
	const [isOpen, setIsOpen] = useState(false)

	const toggle = () => {
		setIsOpen(!isOpen)
	}


	return (
		<>
		 <Sidebar isOpen= {isOpen} toggle={toggle}/>
		 <Navbar toggle={toggle} />
      <HeroSection/>
      <InfoSection {...InfoSectionData}/>
      <ProblemSection {...ProblemSectionData}/>
      <HowtoSection {...HowtoSectionData}/>
      <ContentSection {...ContentSectionData}/>
      <ConsultForm/>
      <PreFooter {...PreFooterData} />
      <ConsoleFooter />
		</>
	)
}

export default Console
